import { Box } from "@mui/material";
import { createFileRoute } from "@tanstack/react-router";
import TextPageComponent from "src/features/TextPageComponent";

export const Route = createFileRoute("/create/_layout/")({
  component: HomePage,
});

function HomePage() {
  return (
    <TextPageComponent
      chipText="Ready to train together?"
      titleText="Time to build your team"
      bodyText="Build a private training team with the people who matter most!"
      customComponent={
        <Box
          component="img"
          src="/assets/teams/teams-1.png"
          sx={{ objectFit: "cover", width: "100%", height: "100%" }}
        />
      }
    />
  );
}
